import classNames from 'classnames'
import React from 'react'

export interface CheckboxProps {
	labelLeft?: string
	checked: boolean
	disabled?: boolean
	variant?: variant
	labelRight?: string
	testId: string
	className?: string
	bold?: boolean
	onChange: (checked: boolean) => void
}

type variant = 'light' | 'dark' | 'white' | 'main' | 'main-dark'

const Checkbox: React.FC<CheckboxProps> = ({
	labelLeft,
	labelRight,
	checked,
	disabled = false,
	variant = 'light',
	testId,
	className,
	bold = false,
	onChange,
}) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (!disabled) {
			onChange(event.target.checked)
		}
	}

	return (
		<label
			className={classNames('checkbox-container', variant, className, labelLeft && 'place-content-between')}
			data-test-id={testId}
			data-disabled={disabled ? 'true' : 'false'}
		>
			{labelLeft && (
				<span
					className={classNames('max-lg:text-sm me-2', {
						'!text-dark-grey': variant === 'dark',
						'text-white': variant === 'white',
						'font-semibold': bold,
					})}
				>
					{labelLeft}
				</span>
			)}
			<div className="checkbox-wrapper">
				<input
					type="checkbox"
					checked={checked}
					onChange={handleChange}
					disabled={disabled}
					className={'checkbox-input'}
				/>
				<span className={'checkmark'}></span>
			</div>
			{labelRight && (
				<span
					className={classNames('ms-2 max-lg:text-sm', {
						'!text-dark-grey': variant === 'dark',
						'text-white': variant === 'white',
						'font-semibold': bold,
					})}
				>
					{labelRight}
				</span>
			)}
		</label>
	)
}

export default Checkbox
